var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-logo",style:({
  paddingLeft:_vm.paddingLeft,
  cursor:'pointer'
}),on:{"click":function($event){return _vm.$router.push('/homes/home')}}},[_c('img',{staticStyle:{"width":"160px","margin-top":"-10px"},attrs:{"src":require("@/assets/logo-img.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }